// @flow
import React from 'react';
import classNames from 'classnames';
import Note from 'app/components/Tariff/Note';

import InformItem from '../InformItem';
import type { Inform } from '../informsDefault';
import enhanceAvailableInformers from './enhanceAvailableInformers';
import styles from './AvailableInformers.scss';


type Props = {
  informs: Array<Inform>,
  footnotes?: Object,
  className?: string,
}

export const AvailableInformersView = ({ informs, footnotes, className }: Props) => (
  <div className={classNames(styles.root, className)}>
    {informs.map(({ id, title, enabled, checked }) =>
      <InformItem
        key={id}
        label={id === 'sms'
          ? <span>
            {title}
            <Note footnotes={footnotes} value="sms" />
          </span>
          : title}
        checked={checked}
        enabled={enabled}
      />)}
  </div>
);

export default enhanceAvailableInformers(AvailableInformersView);
